import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { NgZone, inject } from '@angular/core';
import { LoaderService } from '@core/services';
import { SessionService } from '@core/services/session.service';
import { TokenService } from '@core/services/token.service';
import { SharedDataService } from '@shared/services';
import { catchError, finalize, map, throwError } from 'rxjs';
import { LOADER_KEY } from '../../shared/utils/loader-context.token';

export const LoaderInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const loaderService = inject(LoaderService);
  const dataService = inject(SharedDataService);
  const ngZone = inject(NgZone);
  const sessionService = inject(SessionService);
  const tokenService = inject(TokenService);
  const key = req.context.get(LOADER_KEY);

  ngZone.run(() => {
    dataService.setButtonLoading(true);
    if (key) {
      loaderService.showSectionWiseLoader(key);
    } else {
      loaderService.showLoader();
    }
    // Show loader for each request
  });
  const isMutationRequest = req.method === 'POST' || req.method === 'PUT';

  return next(req).pipe(
    map((event: HttpEvent<unknown>) => {
      if (event instanceof HttpResponse) {
        if (dataService.isAsyncAccordionClick && isMutationRequest) {
          dataService.asyncApiStatus.next(true);
          dataService.isAsyncAccordionClick = false;
        }
      }
      dataService.setButtonLoading(false);
      return event;
    }),
    catchError((err) => {
      if (dataService.isAsyncAccordionClick && isMutationRequest) {
        dataService.asyncApiStatus.next(false);
        dataService.isAsyncAccordionClick = false;
      }
      dataService.setButtonLoading(false);
      if (key) {
        loaderService.hideSectionWiseLoader(key);
      } else {
        loaderService.hideLoader();
      } // Hide loader when the request throws error
      return throwError(() => err);
    }),
    finalize(() => {
      if (tokenService.isAuthenticated()) sessionService.setSession();
      if (key) {
        loaderService.hideSectionWiseLoader(key);
      } else {
        loaderService.hideLoader();
      }
      dataService.setButtonLoading(false);
    }),
  );
};
